import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Button, Col, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import { addUser } from "../../../../../api/usersAPIs";
import { PreviewCard } from "../../../../../components/Component";
import Content from "../../../../../layout/content/Content";

const AddUserPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
    };

    const validationSchema = Yup.object({
        first_name: Yup.string().required("First name is required"),
        last_name: Yup.string().required("Last name is required"),
        email: Yup.string().email("Invalid email format").required("Email is required"),
        phone: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
            .required("Phone number is required"),
        password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .required("Password is required"),
    });

    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true);
        try {
            await addUser(values);
            toast.success("User added successfully");
            resetForm();
            navigate("/customer")
        } catch (error) {
            toast.error("Failed to add user: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Content className="container mt-5">
            <PreviewCard>
                <h3>Add User</h3>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Row className="g-3" xs={1}>
                                <Col size="6">
                                    <label>First Name</label>
                                    <Field name="first_name" className="form-control" placeholder="Enter first name" />
                                    <ErrorMessage name="first_name" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Last Name</label>
                                    <Field name="last_name" className="form-control" placeholder="Enter last name" />
                                    <ErrorMessage name="last_name" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Email</label>
                                    <Field name="email" type="email" className="form-control" placeholder="Enter email" />
                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Phone</label>
                                    <Field name="phone" className="form-control" placeholder="Enter phone number" />
                                    <ErrorMessage name="phone" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Password</label>
                                    <Field name="password" type="password" className="form-control" placeholder="Enter password" />
                                    <ErrorMessage name="password" component="div" className="text-danger" />
                                </Col>

                                <Col size="12">
                                    <div className="d-flex justify-content-end">
                                        <Button color="primary" type="submit" disabled={isSubmitting || loading}>
                                            {loading ? <Spinner size="sm" /> : "Add User"}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </PreviewCard>
        </Content>
    );
};

export default AddUserPage;